import styled, { css } from 'styled-components'
import theme from 'stories/utils/theme'
import { StandardHeadline } from 'stories/elements/Typography/Text'
import SearchBarRedirect from '../widgets/SearchBarRedirect'
import { useRouter } from 'next/router'
import ArrowLeft from 'assets/app/sidebar/arrow-left.svg'

const HeaderContainer = styled.header<{ hideSecondarySection?: boolean; showBackButton?: boolean }>`
    position: fixed;
    top: 0;
    left: 250px;
    right: 360px;
    height: 70px;
    background: #150925;
    display: flex;
    align-items: center;
    padding: 0;
    z-index: ${theme.zIndex.navBar + 1};
    border-bottom: 1px solid #ffffff26;
    ${({ hideSecondarySection }) => (hideSecondarySection ? 'width: 100%;' : '')}
    gap: 20px;
    transition: background-color 0.2s ease;

    @media (max-width: 1250px) {
        left: 125px;
    }

    .seach-wrapper {
        display: flex;
        justify-content: center;
        width: 100%;
        padding: 0 0px 0 25px;
    }
    .center {
        h1 {
            display: flex;
            align-items: center;
            gap: 10px;
            width: 100%;
        }
    }

    .search-container {
        width: 625px;
        h1 {
            position: relative;
            bottom: 10px;
            left: 15px;
        }
        ${({ showBackButton }) =>
            showBackButton
                ? css`
                      @media (max-width: 1250px) {
                          position: relative;
                          left: 25px;
                      }
                  `
                : ''}
    }
    ${({ showBackButton }) =>
        showBackButton
            ? css`
                  .title-container {
                      position: relative;
                      left: 75px;
                  }
              `
            : ''}
`

const BackButton = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    background-color: ${theme.colors.backgroundTransparent};
    height: 50px;
    width: 50px;
    border-radius: 100%;
    position: absolute;
    top: 10px;
    left: 10px;
    padding: 10px;
`

interface Props {
    title?: string | JSX.Element
    showSearch?: boolean
    referrerScreen?: string
    showBackButton?: boolean
    hideSecondarySection?: boolean
    headerComponent?: JSX.Element
}

const AppHeader = ({
    title,
    showSearch,
    referrerScreen = 'app_header',
    showBackButton = false,
    hideSecondarySection,
    headerComponent,
}: Props) => {
    const router = useRouter()
    return (
        <HeaderContainer hideSecondarySection={hideSecondarySection} showBackButton={showBackButton}>
            {showBackButton && (
                <BackButton onClick={() => router.back()}>
                    <ArrowLeft />
                </BackButton>
            )}
            {title && (
                <div className="search-container title-container center">
                    <StandardHeadline fontFamily="var(--font-inter)" fontWeight={500} color={theme.colors.white}>
                        {title}
                    </StandardHeadline>
                </div>
            )}
            {showSearch && (
                <div className="seach-wrapper">
                    <div className="search-container">
                        <SearchBarRedirect referrerScreen={referrerScreen} isDarkTheme={true} />
                    </div>
                </div>
            )}
            {headerComponent && <div className="search-container">{headerComponent}</div>}
        </HeaderContainer>
    )
}

export default AppHeader
